import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import {
  DegreeTraining,
  Email,
  MEDIUM_ITEM_SIZE,
  NameSupplies,
  PhoneNumber,
  Position,
  SuggestionDetails,
  Suggestions,
  Users,
  WorkingDepartment,
} from "./_fields";

type ListCodeTemplate = {
  Users: string;
  NameSupplies: string;
  WorkingDepartment: string;
  Title: string;
  Suggestions: string;
  SuggestionDetails: string;
  DegreeTraining: string;
  Email: string;
  PhoneNumber: number;
};

export const listCodeTemplate: TemplatesValue<ListCodeTemplate> = {
  fileName: "DanhSachNoiDungCapQuyenSDChuongTrinh",
  sheet: DEFAULT_SHEET_NAME,
  structures: [
    Users,
    NameSupplies,
    WorkingDepartment,
    {
      ...Position,
      itemSize: MEDIUM_ITEM_SIZE,
    },
    Suggestions,
    SuggestionDetails,
    {
      ...DegreeTraining,
      header: "Lý do/Trình độ đào tạo",
    },
    {
      ...Email,
      header: "Email liên lạc",
    },
    PhoneNumber,
  ],
  fields: [
    "Users",
    "NameSupplies",
    "WorkingDepartment",
    "Title",
    "Suggestions",
    "SuggestionDetails",
    "DegreeTraining",
    "Email",
    "PhoneNumber",
  ],
};
